import * as React from 'react';
import { connect } from 'react-redux';
import { FromToControl } from '../../../../common/components/from_to_control';
import { IAppState, Dispatch } from '../../../../common/state';
import { IJsonQueryRange } from '../../../../json_query';
import { changeMaxFromMKAD, changeMinFromMKAD } from '../../../state/advanced/from_mkad';
import { InlineParam, Row } from '../markup';

const style = require('../index.css');

export interface IFromMKADProps {
  fromMKAD: { gte?: number; lte?: number };
  onMinValueChanged(value: number | undefined): void;
  onMaxValueChanged(value: number | undefined): void;
  shortView?: boolean;
}

export const fromMKAD: React.StatelessComponent<IFromMKADProps> = props => {
  const fromToControl = (
    <FromToControl
      rangeGroupStyle={style['fromToControl']}
      from={{
        value: props.fromMKAD.gte,
        placeholder: 'от',
        onValueChange: value => props.onMinValueChanged(value),
      }}
      to={{
        value: props.fromMKAD.lte,
        placeholder: 'до',
        onValueChange: value => props.onMaxValueChanged(value),
      }}
    />
  );

  return props.shortView ? (
    fromToControl
  ) : (
    <Row title="Удаленность">
      <InlineParam>{fromToControl}</InlineParam>
      {'км'}
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect<
  { fromMKAD: IJsonQueryRange | {} },
  {
    onMinValueChanged(value: number | undefined): void;
    onMaxValueChanged(value: number | undefined): void;
  },
  { shortView?: boolean }
>(
  (state: IAppState) => ({
    fromMKAD: (state.filters.jsonQuery.from_mcad_km && state.filters.jsonQuery.from_mcad_km.value) || {},
  }),
  (dispatch: Dispatch) => ({
    onMinValueChanged: (value: number | undefined) => {
      dispatch(changeMinFromMKAD(value));
    },
    onMaxValueChanged: (value: number | undefined) => {
      dispatch(changeMaxFromMKAD(value));
    },
  }),
  // tslint:disable-next-line: no-any
)(fromMKAD as any);
